import { Link } from 'gatsby'
import React from 'react'
import Logo from '../logo'

export const LinkLogo = () => (
  <Link
    className="flex-1 flex flex-row items-center max-w-[150px]"
    to="/"
    rel="preload"
    aria-label="Accéder à la page d'accueil"
  >
    <span className="flex-1 py-1">
      <Logo />
    </span>
  </Link>
)
